import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const faqData: FaqItem[] = [
  {
    q: '每日大瓜是什么？',
    a: '每日大瓜是一个聚焦每日爆料吃瓜与吃瓜每日新鲜感的娱乐资讯聚合平台，整合娱乐爆料、网友爆料、社会圈内猛料，以文字截图摘要形式呈现，让你每天都能快速了解圈内最新动态，天天不重样。',
  },
  {
    q: '这里的爆料内容靠谱吗？',
    a: '我们聚合来自多渠道的网友爆料与娱乐资讯，所有内容均标注来源并以"爆料"形式呈现。每日大瓜作为信息聚合平台，不生产原创新闻，所有内容仅供参考，建议读者理性看待并自行核实。',
  },
  {
    q: '更新频率是怎样的？',
    a: '每日早 8 点定时更新当日爆料合集，全天持续追踪热点事件并实时补充最新爆料。热门话题和焦点专题会在首页滚动展示，确保你不错过任何一条猛料。',
  },
  {
    q: '如何向每日大瓜投稿爆料？',
    a: '你可以通过本站投稿通道提交爆料内容。我们支持文字描述和截图上传，所有投稿均为匿名处理，严格保护爆料人隐私。访问投稿通道页面即可开始提交。',
  },
  {
    q: '每日大瓜和传统娱乐新闻有什么区别？',
    a: '传统娱乐新闻侧重权威发布和深度报道，而每日大瓜主打"吃瓜"文化——更轻量、更即时、更接地气。我们聚合网友爆料和圈内消息，用最直接的方式呈现最热乎的内容，省去长篇大论，直击吃瓜核心。',
  },
  {
    q: '手机端可以使用吗？',
    a: '当然可以！每日大瓜支持手机浏览器直接访问，页面已针对移动端做了适配优化。你也可以关注我们的社交媒体账号获取每日推送，随时随地轻松吃瓜。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500">
            关于每日爆料吃瓜，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
              >
                <h3 className="text-sm font-medium text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === idx ? 'subtract' : 'add'
                    }-line text-foreground-400 transition-transform text-lg`}
                  ></i>
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}